export default "__VITE_ASSET__uUOUJ4MO__"